import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { List } from './List';
import { Kiosks } from './kiosks';


function LockerAdmin({ match }) {
    const { path } = match;
    
    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/kiosks`} component={Kiosks} />

        </Switch>
    );
}

export { LockerAdmin };